import dayjs from "../../../utils/dayjsConfig";

export const parseToFloat = (value: string) => {
  return parseFloat(value.toString().replace(",", "."));
};

export const cleanInputString = (input: string): string => {
  if (!input) return "";
  let cleaned = input.replace(/\./g, "");
  cleaned = cleaned.replace(/,/g, ".");

  return cleaned;
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat("es-AR", {
    style: "decimal",
    minimumFractionDigits: 0,
  }).format(amount);
};

export const getAffidavitPath = ({
  isJuridical = false,
  isBuySide = false,
  isResident = true,
}: {
  isJuridical?: boolean;
  isBuySide?: boolean;
  isResident?: boolean;
}) => {
  if (isJuridical || !isResident) {
    return "https://assets.allaria.cloud/docs/Compra-Venta%20DDJJ%20Parking.pdf";
  } else {
    return isBuySide
      ? "https://assets.allaria.cloud/docs/DJ%20Venta%20USD-MEP%2015-09-2025.pdf"
      : "https://assets.allaria.cloud/docs/DJ%20Compra%20USD-MEP%2029-09-2025%20(1).pdf";
  }
};

export const trunc = (number: number, precision = 2) => {
  const factor = Math.pow(10, precision);
  const multiplied = number * factor;
  // Fix rounding errors
  const rounded = Math.round(multiplied);
  // Truncates and returns the correct value
  return Math.trunc(rounded) / factor;
};

// Market hours validator for Argentina (America/Argentina/Buenos_Aires)
export const isArgentinaMarketOpen = (): boolean => {
  const now = dayjs().tz("America/Argentina/Buenos_Aires");
  const dayOfWeek = now.day(); // 0 = Sunday, 6 = Saturday
  if (dayOfWeek === 0 || dayOfWeek === 6) return false;

  const openTime = now.hour(10).minute(45).second(0).millisecond(0);
  const closeTime = now.hour(16).minute(30).second(0).millisecond(0);

  return now.isBetween(openTime, closeTime, null, "[]");
};
